import { getValueByPath } from "shared/app/VerificationTemplate/utils";
import { toMoney } from "shared/utils";
import { VerifiedItem } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified";
import { IncomeField } from "./types";

// Mirrors BuildBenefitsStatement::NET_PERCENTAGE
const BENEFITS_NET_PERCENTAGE = 0.75;

/**
 * Benefit letters are not annualized - BuildBenefitsStatement writes a monthly figure
 * straight onto the item, and the report sums those across the income's live items.
 */
const sumItemDollars = (
  items: VerifiedItem[],
  key: "gross_monthly_income" | "net_monthly_income"
) =>
  items.reduce(
    (sum, item) =>
      sum + ((getValueByPath(item, ["data", key, "cents"]) as number) ?? 0),
    0
  ) / 100;

const isAmountMissing = (items: VerifiedItem[]) =>
  items.some(
    (item) =>
      getValueByPath(item, [
        "income_source_data",
        "additional_data",
        "is_amount_verified"
      ]) === false
  );

export const BenefitsStatementTooltip = ({
  items,
  field,
  displayedMonthly,
  isManualApplicant
}: {
  items: VerifiedItem[];
  field: IncomeField;
  displayedMonthly: number;
  isManualApplicant: boolean;
}) => {
  // Manual apps use 'self-reported' for gross and multiply it by 0.75 for net
  if (isManualApplicant) {
    if (field === "gross") return <>Manually entered gross monthly income</>;

    const grossMonthly = sumItemDollars(items, "gross_monthly_income");
    if (!grossMonthly) return null;

    return (
      <>
        Net monthly income calculation, using manually entered gross monthly
        income
        <br />
        {toMoney(grossMonthly)}*{BENEFITS_NET_PERCENTAGE}
        {" = "}
        {toMoney(displayedMonthly)}
      </>
    );
  }

  if (isAmountMissing(items)) return null;

  return (
    <>Verified {field} monthly income read from the uploaded benefit letter</>
  );
};
